// @ts-nocheck
/* TODO: Can we delete it? */
import React, { FC } from 'react';
import styled from 'styled-components';

import { baseDark } from 'crehana-ui/styles/colors';
import { Container, Row, Col } from 'crehana-ui/GridV2';
import PrimaryButton from 'crehana-ui/Buttons/PrimaryButton';

import { useTranslation } from '@crehana/i18n';

import { EVENTS } from '../../constants';
import Background from './Background';
import { MainSectionProps } from './types';

const Section = styled.section`
  background: radial-gradient(
      119.86% 119.86% at 50% -19.86%,
      rgba(15, 17, 36, 0) 23.77%,
      ${baseDark} 100%
    ),
    linear-gradient(180deg, #4a5390 0%, ${baseDark} 100%);
  ${({ theme }) => theme.breakpoints.up('lg')} {
    padding-top: 190px !important;
    padding-bottom: 190px !important;
    background: none;
    & #videobcg {
      position: absolute;
      z-index: -1;
    }
  }
`;

const MainSection: FC<MainSectionProps> = ({
  title,
  subtitle,
  scrollToSubscriptionPlans,
  backgroundImage,
  buttonLabel,
}) => {
  const { t } = useTranslation();

  return (
    <div className="bg-base-dark">
      <Section
        id="membershipv2-main-section"
        className="relative pt-120 sm:pt-200 pb-120 overflow-hidden"
      >
        <Background backgroundImage={backgroundImage} />
        <Container className="relative z-6">
          <Row className="flex flex-col items-center">
            <Col xs={12} sm={8} lg={9}>
              <div className="flex flex-col items-center ">
                <h1 className="font-main-title text-white text-center mb-24">
                  {title ||
                    t('MAIN_SECTION_TITLE', {
                      defaultValue:
                        'Esta Navidad, regálate educación online por 1 año',
                    })}
                </h1>
                <h2 className="font-body3 text-white text-center mb-32 sm:mb-40">
                  {subtitle ||
                    t('MAIN_SECTION_SUBTITLE', {
                      defaultValue:
                        'Con Premium accederás a +500 cursos y especializaciones por 1 año, ¡para ti y tus personas favoritas!',
                    })}
                </h2>
                <PrimaryButton
                  onClick={() => {
                    scrollToSubscriptionPlans();
                    if (window.gtag) {
                      window.gtag('event', 'Click en Home', {
                        send_to: 'UA-60829200-1',
                        event_category: 'Membresias',
                      });
                    }
                  }}
                  full
                  darkMode
                  label={buttonLabel || t('MAIN_SECTION_BUTTON')}
                  style={{ maxWidth: 280 }}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </Section>
    </div>
  );
};

export default MainSection;
